import React, { useContext, useState } from "react";
import Styles from "./_chat.module.css";
import { SocketContext } from "../../../ioContext/socketIo";
import { useEffect } from "react";
import dateFormat from "dateformat";
import { ImCross } from "react-icons/im";
import { FiSearch } from "react-icons/fi";
import { FaBell } from "react-icons/fa";
import InfiniteScroll from "react-infinite-scroll-component";
import Moment from "react-moment";
import { RotatingLines } from "react-loader-spinner";
import linkifyHtml from "linkify-html";
const Conversation = ({
  batchStdentData,
  setParticularStudent,
  messages,
  SetNumber,
  number,
  setBatchStdentData,
  particularStudent,
  messageread,
  setStop,
  setIsPlaying,
  setRecordedAudio,
  setIsPlaybackActive,
  setIsAudioVisible,
  setRecordedChunks,
  search,
  setSearch,
  HandleSearch,
  HandleClear,
  loadingStudents,
  setIsRecording,
  setSort,
  sort,
  setMsgScroll,
  stopscroll,
  setMessages,
  setSelectedMessages,
  setReply,
  setForward,
  handleSearchConvo,
  handleReset,
  handleLoadMore,
  setCountedData,
  countedData,
}) => {
  const socket = useContext(SocketContext);
  const user1 = sessionStorage.getItem("user");
  const user = JSON.parse(user1);
  let [notification, setNotification] = useState({});
  let [loadmore, SetLoadMore] = useState(false);
  let [notificationCount, setNotificationCount] = useState(0);
  let [searchTrue, setSearchTrue] = useState(false);

  useEffect(() => {
    socket.on("notification_new", (data) => {
      setNotification(data);
    });
  }, []);
  useEffect(() => {
    if (particularStudent?.usernoti > 0) {
      // if (batchName) {
      socket.emit("msgRead_new", {
        senderId: user?._id,
        role: user?.role1,
        receiverId: particularStudent?.studentId,
        seen: true,
        // code: batchName,
        count: notificationCount,
        // type: "batch",
        device: "web",
      });
      setNotificationCount(0);
    } else {
    }
  }, [particularStudent?.studentId, socket]);

  useEffect(() => {
    let data1 = batchStdentData?.map((y) => {
      return y._id === notification?.msg?.from
        ? {
            ...y,
            result: [
              {
                last_msg: notification?.msg,
                user_notification: Number(y?.result[0].user_notification) + 1,
              },
            ],
          }
        : { ...y };
    });
    setBatchStdentData(data1);
    // }
  }, [notification]);

  useEffect(() => {
    let data1 = batchStdentData?.map((x) => {
      return x._id === messages?.slice(-1)[0]?.to
        ? {
            ...x,

            result: [
              {
                last_msg: messages?.slice(-1)[0],
                user_notification: 0,
              },
            ],
          }
        : { ...x };
    });
    setBatchStdentData(data1);
    // }
  }, [messages]);

  let handleNotification = (sid) => {
    let data1 = batchStdentData?.map((x) => {
      if (x?.result[0]?.user_notification > 0) {
        setNotificationCount(x?.result[0]?.user_notification);
      }

      return x._id === sid
        ? x?.result[0]?.user_notification > 0
          ? {
              ...x,
              result: [
                {
                  last_msg: x?.result[0]?.last_msg,
                  user_notification: 0,
                },
              ],
            }
          : { ...x }
        : x;
    });

    setBatchStdentData(data1);
  };

  let d = Date.now();
  let today = dateFormat(d, "mmm d, yyyy");

  let Loadmore = () => {
    if (search.length <= 0) {
      SetNumber(number + 50);
      SetLoadMore(true);
      const c = countedData - 50;
      setCountedData((prev) => {
        return prev - 50;
      });

      handleLoadMore(number + 50);
    }
  };

  let handleSearch = (e) => {
    if (e.target.value.length > 0) {
      let data = e.target.value;
      setSearch(data);
    }
  };

  // let HandleClickSearch = () => {
  //   if (search.length > 0) {
  //     HandleSearch(search);
  //     setSearchTrue(true);
  //   }
  // };
  let HandleClearSearch = () => {
    handleReset();
    setSearchTrue(false);
    // setBatchStdentData([]);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (search.length > 0) {
        handleSearchConvo(search);
        setSearchTrue(true);
      }
    }
  };
  const handleBackspaceUser = (event) => {
    if (event.key === "Backspace" && search.length === 1) {
      handleReset();
      setSearchTrue(false);
      // setBatchStdentData([]);
    }
  };
  let HandleNotificationSort = () => {
    if (sort === true) {
      SetNumber(0);

      setSort(false);
    } else {
      SetNumber(0);
      setSort(true);
    }
  };
  function linkifyHtmlContent(text) {
    // Process the text to convert URLs into clickable links
    const linkifyOptions = {
      defaultProtocol: "https",
      target: "_blank", // Open links in a new tab
      rel: "noopener noreferrer", // For security
    };

    return linkifyHtml(text, linkifyOptions);
  }

  return (
    <>
      <div>
        <div className={Styles.chatMenuWrapper}>
          <div className={Styles.SearchBlock}>
            <span className={Styles.SearchText}>
              <input
                name="search"
                type="text"
                value={search}
                placeholder="Search student"
                onChange={(e) => handleSearch(e)}
                onKeyPress={handleKeyPress}
                onKeyDown={handleBackspaceUser}
              />
            </span>
            &nbsp;
            {searchTrue === false ? (
              <button
                className={Styles.searchIcon}
                onClick={() => {
                  handleSearchConvo();
                  setSearchTrue(true);
                }}>
                <FiSearch />
              </button>
            ) : (
              <button
                className={Styles.searchCancel}
                onClick={HandleClearSearch}>
                <ImCross />
              </button>
            )}
            <div className={Styles.NotySort} onClick={HandleNotificationSort}>
              <FaBell />
            </div>
          </div>

          {loadingStudents ? (
            <div className={Styles.loader}>
              <RotatingLines
                strokeColor="#f16f1d"
                strokeWidth="5"
                animationDuration="0.75"
                width="96"
                visible={true}
              />
            </div>
          ) : (
            <div
              className={Styles.ConversationBlock}
              id="scrollableDiv"
              style={{ height: 550, overflow: "auto" }}>
              <>
                <InfiniteScroll
                  dataLength={batchStdentData?.length}
                  next={Loadmore}
                  hasMore={stopscroll}
                  // loader={<h4>Loading...</h4>}
                  scrollableTarget="scrollableDiv">
                  {batchStdentData?.length === 0 ? (
                    <p style={{ textAlign: "center" }}>No Data Found</p>
                  ) : (
                    batchStdentData
                      .sort((a, b) => {
                        return sort
                          ? new Date(
                              b?.result[0]?.last_msg?.created_at || 0
                            ).getTime() -
                              new Date(
                                a?.result[0]?.last_msg?.created_at || 0
                              ).getTime()
                          : 0;
                      })
                      .map((students, ind) => {
                        return (
                          <div className={Styles.BlockConersation} key={ind}>
                            <div
                              className={Styles.listUser}
                              style={{
                                backgroundImage: `url('https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcRGzAJznGUJCegtKaMXwIvYMmcuBt14EwrlXXjudhc3DIfPnFFa')`,
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                border: "0.3px ridge #999",
                                borderColor:
                                  students?._id == particularStudent.studentId
                                    ? "black"
                                    : null,
                              }}
                              key={ind}
                              onClick={() => {
                                setParticularStudent({
                                  studentId: students?._id,
                                  studentName: students?.username,
                                  notification:
                                    students?.result[0]?.student_notification >
                                    0,
                                  notiCount:
                                    students?.result[0]?.student_notification,
                                  usernoti:
                                    students?.result[0]?.user_notification,
                                });
                                handleNotification(students?._id);
                                setStop(false);
                                setIsPlaying(false);
                                setRecordedAudio(null);
                                setIsPlaybackActive(false);
                                setIsAudioVisible(false); // Hide the audio tag
                                setRecordedChunks([]); // Clear the recorded audio chunks
                                setIsPlaying(false);
                                setIsRecording(false);
                                setSelectedMessages([]);
                                setReply(false);
                                setForward(false);
                                if (
                                  particularStudent?.studentId !==
                                  particularStudent?.studentId
                                ) {
                                  setMessages([]);
                                }
                                setMsgScroll(0);
                              }}>
                              <div className={Styles.conversation}>
                                <span>
                                  {students?.username} -{" "}
                                  {students?.number
                                    ?.toString()
                                    ?.substring(6, 10)}
                                </span>
                                <div
                                  className={
                                    students?.result[0]?.user_notification
                                      ? students?.result[0]
                                          ?.user_notification !== 0
                                        ? `${Styles.notify}`
                                        : `${Styles.nonotify}`
                                      : ""
                                  }>
                                  <span>
                                    {students?.result[0]?.user_notification !==
                                    0
                                      ? students?.result[0]?.user_notification
                                      : ""}
                                  </span>
                                </div>
                              </div>
                              <div className={Styles.tickmark}>
                                <div>
                                  <p
                                    className={
                                      students?.result[0]?.last_msg
                                        ? `${Styles.lastmsg}`
                                        : `${Styles.Nolastmsg}`
                                    }>
                                    <span>
                                      {students?.result[0]?.last_msg ? (
                                        students?.result[0]?.last_msg?.files ? (
                                          `${students?.result[0]?.last_msg.files?.originalname.slice(
                                            0,
                                            15
                                          )}(File)`
                                        ) : students?.result[0]?.last_msg
                                            ?.html ? (
                                          <p
                                            className={Styles.textEditStyle}
                                            style={{ fontSize: "11px" }}>
                                            New Message....
                                          </p>
                                        ) : students?.result[0]?.last_msg?.text
                                            ?.length > 20 ? (
                                          students?.result[0]?.last_msg.text?.slice(
                                            0,
                                            20
                                          ) +
                                          " " +
                                          ". . ."
                                        ) : (
                                          students?.result[0]?.last_msg.text
                                        )
                                      ) : (
                                        <span>No recent message</span>
                                      )}
                                    </span>
                                  </p>
                                </div>
                                <span className={Styles.time}>
                                  {students?.result[0]?.last_msg?.created_at ? (
                                    dateFormat(
                                      students?.result[0]?.last_msg?.created_at,
                                      "mmm d, yyyy"
                                    ) === today ? (
                                      dateFormat(
                                        students?.result[0]?.last_msg
                                          ?.created_at,
                                        "DDDD h:MM TT"
                                      )
                                    ) : (
                                      <Moment format="MMM DD - h:mm a">
                                        {
                                          students?.result[0]?.last_msg
                                            ?.created_at
                                        }
                                      </Moment>
                                    )
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })
                  )}
                </InfiniteScroll>
              </>
            </div>
          )}

          <div className={Styles?.loadmoreBlock}>
            {/* {
              <div className={Styles.loadmoreBlock}>
                <button onClick={Loadmore}>loadmore....</button>
              </div>
            } */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Conversation;
